module.exports = __webpack_public_path__ + "img/4.fb2eb190.png";